(function () {
    'use strict';

    angular
        .module('salesflare.components.tasks.completed', [])
        .component('sfTasksCompleted', {
            controller,
            controllerAs: 'vm',
            templateUrl: 'app-ajs/components/tasks/completed/completed.html',
            bindings: {
                entityCountString: '<', // The amount of tasks in the db
                tasks: '<', // The md-virtual repeat object
                loadingTasks: '<',
                onAddTask: '&',
                onDismissTask: '&',
                onSelectedChanged: '&', // Directly bound to the task event
                onEditTask: '&',
                onOpenMeeting: '&',
                onEditedTask: '&',
                onUpdateTask: '&',
                isTaskFilterApplied: '&',
                usedBadFilter: '<',
                badFilterError: '<',
                setFilters: '&',
                getSearch: '&'
            }
        });

    function controller($mdMedia, $translate, $sce, $sanitize) {

        const vm = this;

        vm.$onInit = function () {

            vm.doneQuote = $translate.instant('No completed tasks yet!');
            vm.noTasksFoundText = $translate.instant('No tasks found');
            // Ideally this would be dynamic but virtual repeat only allows setting it on load basically
            vm.itemSize = $mdMedia('gt-sm') ? 48 : 72;

            const linkText = $translate.instant('this filter');
            const translatedPhrase = $translate.instant('No tasks match {{linkText}}', { linkText });
            // Replace the placeholder with the actual link HTML (ng-click won't work in ng-bind-html, so we use event delegation)
            vm.noTasksMatchHtml = $sce.trustAsHtml(translatedPhrase.replace(linkText, '<a class="click">' + linkText + '</a>'));
        };

        vm.onUpdateTaskProxy = function ($event) {

            return vm.onUpdateTask({
                $event
            });
        };

        vm.onDismissTaskProxy = function ($event) {

            return vm.onDismissTask({
                $event
            });
        };

        vm.onEditTaskProxy = function ($event) {

            return vm.onEditTask({
                $event
            });
        };

        vm.onOpenMeetingProxy = function ($event) {

            return vm.onOpenMeeting({
                $event
            });
        };

        vm.onEditedTaskProxy = function ($event) {

            return vm.onEditedTask({
                $event
            });
        };

        vm.handleNoTasksMatchClick = function ($event) {

            if ($event.target.classList.contains('click')) {
                return vm.setFilters($event);
            }
        };

        /**
         * Returns sanitized and trusted HTML for "Please update the filters to continue." with link.
         *
         * @returns {Object} Trusted HTML for ng-bind-html
         */
        vm.getPleaseUpdateFiltersHtml = function () {
            const raw = $translate.instant('Please update <a href="">the filters</a> to continue.');
            return $sce.trustAsHtml($sanitize(raw));
        };

        vm.handlePleaseUpdateFiltersClick = function ($event) {
            if ($event.target.tagName === 'A') {
                $event.preventDefault();
                vm.setFilters($event);
            }
        };
    }
})();
